import { ViewContainerRef } from '@angular/core';
import { VddFalseTrueReadonlyComponent } from '../../vdd-false-true-readonly/vdd-false-true-readonly.component';
import { VddEnumReadonlyNoIntervalComponent } from '../../vdd-enum-readonly-no-interval/vdd-enum-readonly-no-interval.component';
import { VddNumberReadonlyComponent } from '../../vdd-number-readonly/vdd-number-readonly.component';
import { VddTextReadonlyComponent } from '../../vdd-text-readonly/vdd-text-readonly.component';

export function createVddFalseTrueReadonlyComponent(
  metadataContainer: ViewContainerRef,
  value: string,
  label: string
): void {
  const newComponentRef = metadataContainer.createComponent(VddFalseTrueReadonlyComponent);
  newComponentRef.instance.value = value;
  newComponentRef.instance.label = label;
}

export function createVddEnumReadonlyNoIntervalComponent(
  metadataContainer: ViewContainerRef,
  value: string,
  label: string
): void {
  const newComponentRef = metadataContainer.createComponent(VddEnumReadonlyNoIntervalComponent);
  newComponentRef.instance.value = value;
  newComponentRef.instance.label = label;
}

export function createVddNumberReadonlyComponent(
  metadataContainer: ViewContainerRef,
  value: string,
  label: string,
  unit: string
): void {
  const newComponentRef = metadataContainer.createComponent(VddNumberReadonlyComponent);
  newComponentRef.instance.value = value;
  newComponentRef.instance.label = label;
  newComponentRef.instance.unit = unit;
}

export function createVddTextReadonlyComponent(
  metadataContainer: ViewContainerRef,
  value: string,
  label: string,
  isDescription: boolean
): void {
  const newComponentRef = metadataContainer.createComponent(VddTextReadonlyComponent);
  newComponentRef.instance.value = value;
  newComponentRef.instance.label = label;
  if (isDescription) {
    const nativeElement = newComponentRef.location.nativeElement;
    nativeElement.classList.add('fill-width');
    nativeElement.classList.add('description-divider');
    newComponentRef.instance.isDescription = true;
  }
}
